import { useEffect, useState } from "react";

const MOBILE_BREAKPOINT = 768;

export function useIsMobile() {
  const [isMobile, setIsMobile] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    };

    if (mql && typeof mql.addEventListener === "function") {
      mql.addEventListener("change", onChange);
    }
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);

    return () => {
      if (mql && typeof mql.removeEventListener === "function") {
        mql.removeEventListener("change", onChange);
      }
    };
  }, []);

  return !!isMobile;
}
